import request from '@/utils/request'
// 概况
export function gk () {
    return request( {
        url: '/Index/gk',
        method: 'get'
    } )
}
// 北向资金 分时
export function bxzjmin ( query ) {
    return request( {
        url: '/Zjlx/bxzjmin',
        method: 'get',
        params: query
    } )
}
// 北向资金 资金余额分时
export function bxzjyemin ( query ) {
    return request( {
        url: '/Zjlx/bxzjyemin',
        method: 'get',
        params: query
    } )
}
// 北向资金 历史走势
export function bxhis ( query ) {
    return request( {
        url: '/Zjlx/bxhis',
        method: 'get',
        params: query
    } )
}
// 南向资金 分时
export function nxzjmin ( query ) {
    return request( {
        url: '/Zjlx/nxzjmin',
        method: 'get',
        params: query
    } )
}
// 南向资金 资金余额分时
export function nxzjyemin ( query ) {
    return request( {
        url: '/Zjlx/nxzjyemin',
        method: 'get',
        params: query
    } )
}
// 南向资金 历史走势
export function nxhis ( query ) {
    return request( {
        url: '/Zjlx/nxhis',
        method: 'get',
        params: query
    } )
}

// 沪深港通历史流入
export function hsgtlxls ( query ) {
    return request( {
        url: '/Lssj/hsgtlxls',
        method: 'get',
        params: query
    } )
}
// 沪深港通十大成交股
export function hsgtsdcj ( query ) {
    return request( {
        url: '/Lssj/hsgtsdcj',
        method: 'get',
        params: query
    } )
}

//成交明细 /lssj/hkcjmx?stock=HK00001&page=1&size=10 (这些是默认值)
export function hkcjmx ( query ) {
    return request( {
        url: '/Lssj/hkcjmx',
        method: 'get',
        params: query
    } )
}

// 持股变动 /lssj/agcgbd?stock=SH600018&page=1&size=10  (这些是默认值)
export function agcgbd ( query ) {
    return request( {
        url: '/Lssj/agcgbd',
        method: 'get',
        params: query
    } )
}

// 持股比例
export function cgbl ( query ) {
    return request( {
        url: '/Lssj/cgbl',
        method: 'get',
        params: query
    } )
}

// 云平台token
export function stockinfo ( query ) {
    return request( {
        url: '/Lssj/stockinfo',
        method: 'get',
        params: query
    } )
}





// 新版的北向资金 首页
export function getTotal ( query) {
    return request( {
        url: '/zjlx/getTotal',
        method: 'get',
        params: query
    } )
}

// 新版历史走向
export function getBxLszs ( query ) {
    return request( {
        url: '/Lssj/bxLsCharts',
        method: 'get',
        params: query
    } )
}

// 获取 云平台K线图(历史数据)
export function getYunKlint (query) {
    return request( {
        url: '/Lssj/getYunZxt',
        method: 'get',
        params: query
    } )
}

// 获取今日 指数行情(收盘价)
export function getYunSpjToSf ( query) {
    return request( {
        url: '/Lssj/getYunSpjToSf',
        method: 'get',
        params: query
    } )
}

// 概况
export function gkInfo () {
    return request( {
        url: '/Index/total',
        method: 'get'
    } )
}


// 成交总额 额度余额
export function becomeTotal () {
    return request( {
        url: '/Index/becomeTotal',
        method: 'get'
    } )
}


// 交易日历
export function Calendars () {
    return request( {
        url: window.CALENDAES_API,
        method: 'get'
    } )
}
